// extracted by mini-css-extract-plugin
export var searchHeader = "_6f-0";
export var searchHeaderDark = "_6f-1";